/* MARELD V11: menu/topbar access to the existing Spotlight drawer. */
(() => {
  if (window.MareldBenefitsAccess) { window.MareldBenefitsAccess.init(); return; }
  const selector = '[data-mareld-benefits-open]';
  let busy = false;
  const drawer = () => [...document.querySelectorAll('spotlight-pick')]
    .find(node => node.isConnected && typeof node.show === 'function');
  const init = () => {
    const target = drawer();
    document.querySelectorAll(selector).forEach(control => {
      control.hidden = !target;
      control.setAttribute('aria-expanded', String(Boolean(target?.open)));
    });
  };
  document.addEventListener('click', async event => {
    const control = event.target.closest?.(selector);
    if (!control) return;
    event.preventDefault();
    const target = drawer();
    if (!target || busy) return;
    busy = true;
    try {
      const menu = control.closest('menu-drawer');
      // Return to the visible hamburger after closing benefits, not into a hidden menu.
      const returnTarget = menu?.open ? menu.activeElement : control;
      if (menu?.open && typeof menu.hide === 'function') {
        await menu.hide();
        // Pillar releases the menu focus trap in its next task.
        await new Promise(resolve => setTimeout(resolve, 0));
      }
      if (target.isConnected && control.isConnected) {
        await target.show(returnTarget || control);
      }
    } finally {
      busy = false;
      init();
    }
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('spotlight-pick')) init();
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
  window.MareldBenefitsAccess = {init};
  customElements.whenDefined('spotlight-pick').then(init);
  init();
})();
